import React, { forwardRef, useImperativeHandle } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { findDisplayName } from "../../../../utils/commonFunctionsAndStatices";

const DynamicFieldsForm = forwardRef(
  ({ onSubmitFromParent, selectedFieldType }, ref) => {
    const { register, control, handleSubmit, getValues} = useForm({
      defaultValues: {
        fields: [{ key: "", value: "" }],
      },
    });

    const { fields, append, remove } = useFieldArray({
      control,
      name: "fields",
    });

    const getFormData = () => {
      return getValues();
    };

    const onSubmit = () => {
      const formData = getValues();
      onSubmitFromParent(formData);
    };

    // Expose the handleSubmit function to the parent component using ref
    useImperativeHandle(ref, () => ({
      submit: handleSubmit(onSubmit),
      getFormData: getFormData,
    }));

    return (
      <div className="container mt-3">
        <div className=" ">
          <form ref={ref}>
            {fields.map((field, index) => (
              <div key={field.id} className="row field ">
                {selectedFieldType !== "Radio" && (
                  <div className="form-group col-lg-4 col-md-8 col-sm-12 mt-3">
                    <label htmlFor={`key-${index}`}>
                      {findDisplayName("fieldCreateKeyHeading", "Key")}
                    </label>
                    <input
                      type="text"
                      id={`key-${index}`}
                      {...register(`fields[${index}].key`)}
                      placeholder={findDisplayName(
                        "fieldCreateKeyInputBox",
                        "Key"
                      )}
                      className="form-control"
                    />
                  </div>
                )}
                <div className="form-group col-lg-4 col-md-8 col-sm-12 mt-3">
                  <label htmlFor={`value-${index}`}>
                    {findDisplayName("fieldCreateValueHeading", "Value")}
                  </label>
                  <input
                    type="text"
                    id={`value-${index}`}
                    {...register(`fields[${index}].value`)}
                    placeholder={findDisplayName(
                      "fieldCreateValueInputBox",
                      "Value"
                    )}
                    className="form-control"
                  />
                </div>
                <div className="form-group col-lg-2 col-md-8 col-sm-12 mt-3 pt-4">
                  <button
                    type="button"
                    onClick={() => append({ key: "", value: "" })}
                    className="btn btn-primary rounded-circle ms-1"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                      style={{ transform: "scale(1.5)" }}
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                    </svg>{" "}
                  </button>
                  <button
                    type="button"
                    onClick={() => remove(index)}
                    className="btn rounded-circle ms-3 btn-dark btn-danger"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="20"
                      viewBox="0 0 16 20"
                      fill="none"
                    >
                      <path
                        d="M6.77484 7.87549C6.77484 7.59935 6.55098 7.37549 6.27484 7.37549C5.9987 7.37549 5.77484 7.59935 5.77484 7.87549H6.77484ZM5.77484 15.8755C5.77484 16.1516 5.9987 16.3755 6.27484 16.3755C6.55098 16.3755 6.77484 16.1516 6.77484 15.8755H5.77484ZM10.7748 7.87549C10.7748 7.59935 10.551 7.37549 10.2748 7.37549C9.9987 7.37549 9.77484 7.59935 9.77484 7.87549H10.7748ZM9.77484 15.8755C9.77484 16.1516 9.9987 16.3755 10.2748 16.3755C10.551 16.3755 10.7748 16.1516 10.7748 15.8755H9.77484ZM3.36686 18.6575L3.59386 18.212L3.36686 18.6575ZM2.49283 17.7835L2.93833 17.5565H2.93833L2.49283 17.7835ZM14.0569 17.7835L13.6114 17.5565L14.0569 17.7835ZM13.1828 18.6575L12.9558 18.212H12.9558L13.1828 18.6575ZM1.27484 4.37549C0.998699 4.37549 0.774841 4.59934 0.774841 4.87549C0.774841 5.15163 0.998699 5.37549 1.27484 5.37549V4.37549ZM15.2748 5.37549C15.551 5.37549 15.7748 5.15163 15.7748 4.87549C15.7748 4.59934 15.551 4.37549 15.2748 4.37549V5.37549ZM4.27484 4.87549C4.27484 5.15163 4.4987 5.37549 4.77484 5.37549C5.05098 5.37549 5.27484 5.15163 5.27484 4.87549H4.27484ZM11.2748 4.87549C11.2748 5.15163 11.4987 5.37549 11.7748 5.37549C12.051 5.37549 12.2748 5.15163 12.2748 4.87549H11.2748ZM5.77484 7.87549V15.8755H6.77484V7.87549H5.77484ZM9.77484 7.87549V15.8755H10.7748V7.87549H9.77484ZM13.7748 4.87549V15.6755H14.7748V4.87549H13.7748ZM11.0748 18.3755H5.47484V19.3755H11.0748V18.3755ZM1.77484 4.87549V15.6755H2.77484V4.87549H1.77484ZM5.47484 18.3755C4.90654 18.3755 4.51038 18.3751 4.20196 18.3499C3.89938 18.3252 3.72553 18.2791 3.59386 18.212L3.13987 19.103C3.43601 19.2539 3.7561 19.3168 4.12053 19.3466C4.47912 19.3759 4.92304 19.3755 5.47484 19.3755V18.3755ZM1.77484 15.6755C1.77484 16.2273 1.77445 16.6712 1.80375 17.0298C1.83353 17.3942 1.89643 17.7143 2.04733 18.0105L2.93833 17.5565C2.87124 17.4248 2.82515 17.251 2.80043 16.9484C2.77523 16.6399 2.77484 16.2438 2.77484 15.6755H1.77484ZM3.59386 18.212C3.31161 18.0682 3.08214 17.8387 2.93833 17.5565L2.04732 18.0105C2.28701 18.4809 2.66946 18.8633 3.13987 19.103L3.59386 18.212ZM13.7748 15.6755C13.7748 16.2438 13.7745 16.6399 13.7493 16.9484C13.7245 17.251 13.6784 17.4248 13.6114 17.5565L14.5024 18.0105C14.6533 17.7143 14.7162 17.3942 14.7459 17.0298C14.7752 16.6712 14.7748 16.2273 14.7748 15.6755H13.7748ZM11.0748 19.3755C11.6266 19.3755 12.0706 19.3759 12.4292 19.3466C12.7936 19.3168 13.1137 19.2539 13.4098 19.103L12.9558 18.212C12.8241 18.2791 12.6503 18.3252 12.3477 18.3499C12.0393 18.3751 11.6431 18.3755 11.0748 18.3755V19.3755ZM13.6114 17.5565C13.4675 17.8387 13.2381 18.0682 12.9558 18.212L13.4098 19.103C13.8802 18.8633 14.2627 18.4809 14.5024 18.0105L13.6114 17.5565ZM1.27484 5.37549H2.27484V4.37549H1.27484V5.37549ZM2.27484 5.37549H14.2748V4.37549H2.27484V5.37549ZM14.2748 5.37549H15.2748V4.37549H14.2748V5.37549ZM5.27484 4.07549C5.27484 2.62555 6.57487 1.37549 8.27484 1.37549V0.375488C6.10882 0.375488 4.27484 1.99081 4.27484 4.07549H5.27484ZM8.27484 1.37549C9.97481 1.37549 11.2748 2.62555 11.2748 4.07549H12.2748C12.2748 1.99081 10.4409 0.375488 8.27484 0.375488V1.37549ZM4.27484 4.07549V4.87549H5.27484V4.07549H4.27484ZM11.2748 4.07549V4.87549H12.2748V4.07549H11.2748Z"
                        fill="#FF6060"
                      />
                    </svg>{" "}
                  </button>
                </div>
              </div>
            ))}
          </form>
        </div>
      </div>
    );
  }
);

export default DynamicFieldsForm;
